import { Files } from '../../lib/constants/files'
import {
  AdminStaffInput,
  AdminStaffUpdateRequest
} from '../../lib/types/models/staff/admin-staff-input'
import { Staff } from '../../lib/types/models/staff/staff'
import { NullableTransformer, UpdateInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const adminUpdateStaff = async (
  input: UpdateInput<NullableTransformer<AdminStaffInput>>
) => {
  const { id, ...data } = input
  const picture = await uploadFile(Files.STAFF_PROFILE_PICTURE, data.picture)
  const criminalRecord = await uploadFile(Files.STAFF_CRIMINAL_RECORD, data.criminalRecord)
  const identityDocument = await uploadFile(Files.STAFF_IDENTITY_DOCUMENT, data.idFile)
  const paySlip = await uploadFile(Files.STAFF_PAYSLIP, data.paySlip)
  const eta = await uploadFile(Files.ETA, data.eta)
  // Resolve all diploma file uploads
  const diplomas = data.diplomas
    ? await Promise.all(
        data.diplomas.map(async (diploma) => {
          const file = (await uploadFile(Files.STAFF_DIPLOMA, diploma.file)) ?? undefined
          return { ...diploma, file }
        })
      )
    : undefined

  const req: NullableTransformer<AdminStaffUpdateRequest> = {
    ...data,
    availabilities: data.availabilities?.map(({ startDate, endDate }) => ({ startDate, endDate })),
    comments: data.comments?.map(
      ({ comment, displayForDirector, displayInPlanning, subject, id }) => ({
        ...(id && { id }),
        comment,
        displayInPlanning,
        displayForDirector,
        subjectId: subject?.id
      })
    ),
    picture,
    eta,
    criminalRecord,
    idFile: identityDocument,
    paySlip,
    diplomas // Assign resolved diplomas array here
  }
  return restApiClient
    .url(constructApiUrl(API.staffs.adminUpdate.url, { id }))
    .patch<Staff, NullableTransformer<AdminStaffUpdateRequest>>(req)
}
